import { GlDisclosureDropdownGroup, GlDisclosureDropdownItem } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { generateAnalyticsDashboardLink } from '~/analytics/shared/utils';
import { OVERLAY_GOTO } from '~/super_sidebar/components/global_search/command_palette/constants';
import FrequentItem from '../../../../../../../app/assets/javascripts/super_sidebar/components/global_search/components/frequent_item.vue?vue3';
import FrequentItemSkeleton from '../../../../../../../app/assets/javascripts/super_sidebar/components/global_search/components/frequent_item_skeleton.vue?vue3';
import { TRACKING_ACTION_CLICK_DASHBOARD_ITEM } from './tracking';
export default {
    name: 'DashboardItemsList',
    i18n: {
        OVERLAY_GOTO
    },
    components: {
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        FrequentItem,
        FrequentItemSkeleton
    },
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        emptyStateText: {
            type: String,
            required: true
        },
        groupName: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        isGroup: {
            type: Boolean,
            required: false,
            default: false
        },
        dashboardName: {
            type: String,
            required: true
        },
        bordered: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        formattedItems () {
            return this.items.map((item)=>{
                const dashboardHref = generateAnalyticsDashboardLink({
                    namespacePath: item.fullPath,
                    isGroup: this.isGroup,
                    dashboardSlug: this.dashboardName
                });
                return {
                    forDropdown: {
                        id: item.id,
                        text: item.name,
                        href: dashboardHref,
                        extraAttrs: {
                            'data-track-action': TRACKING_ACTION_CLICK_DASHBOARD_ITEM,
                            'data-track-label': this.isGroup ? 'group' : 'project',
                            'data-track-property': this.dashboardName
                        }
                    },
                    forRenderer: {
                        id: item.id,
                        title: item.name,
                        subtitle: item.namespace,
                        avatar: item.avatarUrl
                    }
                };
            });
        },
        showEmptyState () {
            return !this.loading && this.formattedItems.length === 0;
        }
    }
};
